import React from 'react';
import { Icon } from '@material-ui/core';

import Utils from 'utils/Utils';

import './InviteFriendsWidget.scss';

function InviteFriendsWidget({ Request }) {
  
  if (!Request) return <div />;

  const url = `https://api.whatsapp.com/send/?text=Bora%20comigo%20nessa?%20Neste%20link%20a%C3%AD%20tem%20as%20informa%C3%A7%C3%B5es%20e%20tamb%C3%A9m%20j%C3%A1%20pode%20se%20inscrever!%20%20%20${Request.short_url}&app_absent=0`

  return (
    <div className="invite-friends">
      <h1>Convidar amigos</h1>
      <p>Este é o link deste evento:</p>
      <span>Compartilhe para convidar seus amigos e para que eles reservem suas vagas</span>
      <input type="text" disabled value={Request.short_url} />
      <div className="buttons-share">
        <button onClick={ () => { window.open(url, '_blank'); }} type="button" className="button-invite-friends icons-share">
              <i className="fa fa-whatsapp icon-item" /> Enviar pelo WhatsApp
        </button>
        <button onClick={() => Utils.shareLink(Request.short_url)} type="button" className="button-invite-friends icons-share">
          <i className="fa fa-copy icon-item-copy" /> Copiar link
        </button>
      </div>
    </div>
  );
}

export default InviteFriendsWidget;
